/**
 * Шаг 1 активации — Знакомство.
 * 3 карточки «1-2-3» + пруф 84К/28К.
 * Это объяснительный шаг, бэк не дёргаем — переход локальный.
 */
export function StepIntro({ onNext }: { onNext: () => void }) {
  return (
    <div className="step-intro">
      <div className="intro-header">
        <h2 className="intro-title">
          Бесплатные читатели — <em>из&nbsp;поиска</em>
        </h2>
        <p className="intro-sub">
          Витрина публикует ваши посты на портале telegraphyx.ru. За 5-14 дней страницы попадают в поиск,
          а читатели — в ваш канал. Никакой рекламы, всё работает само.
        </p>
      </div>

      <div className="intro-cards">
        <article className="intro-card">
          <div className="intro-num">1</div>
          <h3 className="intro-card-title">Публикуем посты</h3>
          <p className="intro-card-text">
            Каждый ваш пост превращается в отдельную страницу на telegraphyx.ru. Мы готовим её к&nbsp;поиску
            автоматически — без вашего участия.
          </p>
        </article>

        <article className="intro-card">
          <div className="intro-num">2</div>
          <h3 className="intro-card-title">Поисковики находят</h3>
          <div className="intro-engines">
            <div className="intro-engine yandex">
              <svg viewBox="0 0 24 24" fill="white"><path d="M13.7 18h-1.9V9.5h-1.5l-.4 7.5H8.5l-.5-9h2.7l.5 8 1.4-8H14L13.7 18z" /></svg>
              <span>Яндекс</span>
            </div>
            <div className="intro-engine google">
              <svg viewBox="0 0 24 24"><path fill="#4285F4" d="M21.35 11.1H12v3.2h5.35c-.23 1.2-.92 2.2-1.95 2.9v2.4h3.16c1.84-1.7 2.9-4.2 2.9-7.05 0-.66-.06-1.3-.16-1.9-.06-.45-.16-.9-.3-1.3z"/><path fill="#34A853" d="M12 22c2.6 0 4.8-.85 6.4-2.4l-3.16-2.4c-.88.6-2 .95-3.24.95-2.5 0-4.6-1.7-5.36-3.95H3.4v2.5C5 19.6 8.25 22 12 22z"/><path fill="#FBBC05" d="M6.64 14.2c-.18-.6-.3-1.3-.3-2.2s.1-1.6.3-2.2V7.3H3.4C2.6 8.7 2 10.3 2 12s.4 3.3 1.2 4.7l3.45-2.5z"/><path fill="#EA4335" d="M12 5.65c1.4 0 2.7.5 3.7 1.5l2.8-2.8C16.8 2.65 14.6 2 12 2 8.25 2 5 4.4 3.4 7.3l3.25 2.5C7.4 7.35 9.5 5.65 12 5.65z"/></svg>
              <span>Google</span>
            </div>
          </div>
          <p className="intro-card-text">
            5-14 дней — и&nbsp;ваши страницы появляются в&nbsp;поиске. Портал telegraphyx.ru уже хорошо
            известен Яндексу и&nbsp;Google, поэтому ваши новые страницы попадают в&nbsp;поиск быстрее,
            чем у&nbsp;нового сайта.
          </p>
        </article>

        <article className="intro-card">
          <div className="intro-num">3</div>
          <h3 className="intro-card-title">Читатели переходят в&nbsp;канал</h3>
          <p className="intro-card-text">
            На&nbsp;каждой странице — кнопка «Читать в&nbsp;канале». Клик ведёт прямо в&nbsp;MAX.
            Мы&nbsp;сами считаем сколько людей пришло, какие посты заходят лучше — увидите всё
            в&nbsp;разделе «Витрина».
          </p>
        </article>
      </div>

      <div className="intro-proof">
        <div className="proof-item">
          <div className="proof-num">84 000</div>
          <div className="proof-lab">страниц уже в&nbsp;поиске</div>
        </div>
        <div className="proof-sep" />
        <div className="proof-item">
          <div className="proof-num">28 000</div>
          <div className="proof-lab">читателей/мес из&nbsp;поисковиков</div>
        </div>
      </div>

      <div className="intro-cta">
        <button className="cta-primary" onClick={onNext}>
          Дальше — согласие
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </button>
      </div>

      <style>{`
        .step-intro {
          display: flex;
          flex-direction: column;
          gap: 28px;
        }
        .intro-header {
          text-align: center;
          max-width: 640px;
          margin: 0 auto;
        }
        .intro-title {
          font-size: 30px;
          font-weight: 800;
          margin: 0 0 10px;
          color: var(--tg-ink, #111);
          letter-spacing: -0.02em;
        }
        .intro-title em {
          font-style: normal;
          background: linear-gradient(135deg, #0066ff, #5a8dff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        .intro-sub {
          font-size: 15px;
          color: var(--tg-mute, #5b6678);
          line-height: 1.55;
          margin: 0;
        }
        .intro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
        }
        @media (max-width: 800px) {
          .intro-cards { grid-template-columns: 1fr; }
        }
        .intro-card {
          background: var(--tg-surface, #fff);
          border: 1px solid var(--tg-line-2, #f0f0f4);
          border-radius: 14px;
          padding: 20px 22px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .intro-num {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: var(--tg-blue-bg, #ebf2ff);
          color: var(--tg-blue-press, #0052cc);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 13px;
          margin-bottom: 4px;
        }
        .intro-card-title {
          font-size: 15px;
          font-weight: 700;
          color: var(--tg-ink, #111);
          margin: 0;
        }
        .intro-card-text {
          font-size: 13px;
          color: var(--tg-mute, #5b6678);
          line-height: 1.5;
          margin: 0;
        }
        .intro-engines {
          display: flex;
          gap: 8px;
          margin: 4px 0 4px;
        }
        .intro-engine {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 5px 10px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 600;
        }
        .intro-engine svg { width: 14px; height: 14px; flex-shrink: 0; }
        .intro-engine.yandex { background: #FC3F1D; color: white; }
        .intro-engine.yandex svg { background: white; border-radius: 50%; padding: 1px; box-sizing: border-box; }
        .intro-engine.yandex svg path { fill: #FC3F1D; }
        .intro-engine.google { background: var(--tg-paper, #fafafd); color: var(--tg-ink, #111); border: 1px solid var(--tg-line-2, #f0f0f4); }
        .intro-proof {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 28px;
          padding: 18px 28px;
          background: var(--tg-paper, #fafafd);
          border-radius: 14px;
        }
        .proof-item { text-align: center; }
        .proof-num {
          font-size: 22px;
          font-weight: 800;
          color: var(--tg-ink, #111);
          font-variant-numeric: tabular-nums;
        }
        .proof-lab {
          font-size: 11.5px;
          color: var(--tg-mute, #5b6678);
          margin-top: 2px;
        }
        .proof-sep {
          width: 1px;
          height: 32px;
          background: var(--tg-line-2, #f0f0f4);
        }
        .intro-cta {
          display: flex;
          justify-content: center;
          padding-top: 8px;
        }
        .cta-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 13px 24px;
          background: var(--tg-blue, #0066ff);
          color: white;
          font-weight: 700;
          font-size: 14px;
          border: 0;
          border-radius: 12px;
          cursor: pointer;
          font-family: inherit;
          transition: background 150ms;
          box-shadow: 0 4px 16px -4px rgba(0,102,255,0.35);
        }
        .cta-primary:hover { background: var(--tg-blue-press, #0052cc); }
        .cta-primary svg { width: 16px; height: 16px; }
        @media (max-width: 600px) {
          .intro-title { font-size: 24px; }
          .intro-proof { flex-direction: column; gap: 14px; padding: 14px 20px; }
          .proof-sep { display: none; }
        }
      `}</style>
    </div>
  )
}
